import { ElNotification } from 'element-plus';

export const showNotification = (title, message, type, duration = 4500) => {
    ElNotification({
        dangerouslyUseHTMLString: true,
        title,
        message,
        type,
        duration
    });
};